import './rule.css'
import {Link} from 'react-router-dom';

function Rule(){
    return(
        <div className="rule">
           <div className="container">
              <div className="rule-inner">
                  <h1>Условия заказа, доставки и оплаты:</h1>
                  <div className="rule-item">
                     <h2>Заказ на сайте:</h2>
                     <p>1.Вы выбираете нужные или интересные товары в магазине. Затем добавляете их в корзину. 
                         Количество выбираете сами. Заполнив нужные поля отпраляйте заказ к нам.
                         Он будет обработан в течении дня, затем мы позвоним вам для уточнения заказа.
                        <br></br>2.Если вы не ответите на наш звонок, то мы свяжемся с вами с помощью Whatsapp. В крайнем случае мы отклоним ваш заказ
                        <br></br>3.Если вы хотите заказать у нас в крупном обьёме, то советуем делать это не через наш 
                        интернет магазин, а напрямую связавшись с нами.
                     </p>
                  </div>

                  <div className="rule-item">
                      <h2>Доставка и самовывоз:</h2>
                      <p>1. Вы можете забрать свой заказ, адрес самовывоза находится во вкладке контакты.<br></br>
                         2. Доставка осуществляется через курьера поэтому взымается отдельная плата.
                      </p>
                  </div>

                  <div className="rule-item">
                      <h2>Оплата:</h2>
                      <p>Если вы выбираете самовывоз то оплата при получение заказа. <br></br>
                         Если вы выбираете доставку на дом то вы должны оплатить перед получением через банковский перевод. <br></br>
                         Мы принимаем оплату через Каспи перевод, Qr или наличными.
                      </p>
                  </div>

                  <h3>Если вы ознакомились с правилами то можете приступать к покупкам.</h3>

                  <Link to="/store" className="goshop">в магазин</Link>


                </div>
            </div>
        </div>
    )

}

export default Rule